
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCpej9I47XpI5_Jhkb1QtLmQoMx7arfL_I",
  authDomain: "portfolio-dashboard-8f606.firebaseapp.com",
  projectId: "portfolio-dashboard-8f606",
  storageBucket: "portfolio-dashboard-8f606.appspot.com",
  messagingSenderId: "844263294160",
  appId: "1:844263294160:web:6d862b086db53c90660ad5"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth();
const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);


export const signInWithGoogle = () => signInWithPopup(auth, provider);